import { computed, ComputedRef } from 'vue'

// State
import store from "@/vue/planning/store/store"
import { getCookie } from '@/utils/utils'
import getSiteFromDomain from "@/vue/planning/logic/getSiteFromDomain"

//ie. https://docs.travelski.com/legal-docs/www.nl.travelski.com/CGV/index.pdf

const conditionsUrl: ComputedRef<string> = computed(() => {
    const locale: string = String(store.getters.locale).replaceAll("-", "_");
    let specialCseLocale: string = locale === "fr_FR_CSE" ? "/FR" : "";
    if (locale === "fr_FR_CSE" && getCookie("companyLang") === "nl") {
        specialCseLocale = "/NL";
    }
    return `https://docs.travelski.com/legal-docs/${getSiteFromDomain(window.location.hostname, store.getters.locale)}/CGV${specialCseLocale}/index.pdf?ts=${Date.now()}`;
})
export default conditionsUrl